import { BasicSeries, Rating } from '../../../types/deal.types';
import { isDefined } from '../../../utils/utils';
import {
  EnhancedRating,
  isEachNotRated,
  isEquivalent,
  RATING_AGENCIES
} from './../../../helpers/issue/ratings';

export interface RatingsGridViewModel {
  moody: EnhancedRating[];
  sp: EnhancedRating[];
  fitch: EnhancedRating[];
  kroll: EnhancedRating[];
}

export function ratingsValueGetter({ data }): RatingsGridViewModel {
  const result = {
    moody: [],
    sp: [],
    fitch: [],
    kroll: []
  } as RatingsGridViewModel;
  if (data.series) {
    data.series.forEach((series: BasicSeries) => {
      series.ratings.forEach((rating: Rating) => {
        const enhancedRating = {
          ...rating,
          enhancement: series.insurer
        } as EnhancedRating;

        const key = RATING_AGENCIES.find(
          (agency) => agency.name === rating.agency
        ).key;

        if (
          result[key].findIndex((existing) =>
            isEquivalent(existing, enhancedRating)
          ) === -1
        ) {
          result[key].push(enhancedRating);
        }
      });
    });
  }

  return result;
}

export function reduceRatingValues(
  ratings: RatingsGridViewModel,
  agencyKey: string
): string {
  const agencyRatings = ratings[agencyKey];

  // Rendering value for multi series
  if (agencyRatings.length > 1) {
    const allRatings = agencyRatings.map((r) => {
      return isDefined(r.rating) ? r.rating.trim() : r.rating;
    });
    const uniqueRatings = new Set(allRatings);

    // If all ratings are same, return the first value
    if (uniqueRatings.size === 1) {
      return Array.from(uniqueRatings.values())[0] as string;
    }

    // If ratings are different, return 'various'
    return 'Var';
  }

  // Rendering value for single series
  return agencyRatings[0]?.rating;
}

export const getAgencyKey = (agencyName: string) => {
  return RATING_AGENCIES.find((agency) => agency.name === agencyName)?.key;
};

export function reduceValues(ratings: Rating[]): string {
  if (isEachNotRated(ratings)) {
    return null;
  }

  if (ratings.length > 1) {
    return 'Var';
  }

  return ratings[0]?.rating || ratings[0]?.shortTerm;
}